import { createUseStyles } from "react-jss";
export function useStylesHook(styles) {
    const useStyles = createUseStyles(styles);
    return useStyles();
}
